import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCSVReport } from '../selectors';
import { noop } from '../../../common/propTypes';
import LoadingComponent from '../../../common/LoadingComponent';

function DownloadReport({
    buttonText,
    report,
    onDownloadClick,
    loading,
    disabled,
}) {
    return report.length ? (
        <button
            onClick={() => onDownloadClick('png')}
            type="button"
            className="btn btn-custom"
            disabled={disabled}
        >
            {loading ? (
                <div className="buttonLoader">
                    <LoadingComponent isLoading={loading} />
                </div>
            ) : (
                buttonText
            )}
        </button>
    ) : null;
}

DownloadReport.propTypes = {
    report: PropTypes.array,
    buttonText: PropTypes.string,
    onDownloadClick: PropTypes.func,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
};

DownloadReport.defaultProps = {
    buttonText: 'Download Image',
    report: [],
    onDownloadClick: noop,
    loading: false,
    disabled: false,
};

const mapStateToProps = (state) => {
    return {
        report: getCSVReport(state),
    };
};

export default connect(mapStateToProps, null)(DownloadReport);
